// import { HtmlTagDescriptor } from "vite";
// import { GameEvent } from "../enums/GameEvent";
import { Page } from "../enums/Page";
import { css, html } from "../helpers/webComponents";

const styles: string = css`
:host {
height: 100%;
display: flex;
width: 100%
background-color: black;
justify-content: center;
align-items: center;
}
`;

export const DefaultPage: Page = Page.Canvas;

export class PageBackpackComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }
        const element: HTMLElement = this.renderKeypad();

        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);
    }

    private renderKeypad(): HTMLElement {
        const element: HTMLElement = html`
        <div> 
        <style>
        ${styles} 
        </style>
        <div>
        <game-backpack> <style>${styles}</style>
        <div class="keypad"></div></game-backpack>
        </div>
        </div>
        `;
        return element;
    }
}
